export const inputStyles = {
  '& .MuiInputBase-root': {
    height: '100%',
    borderBottom: 'none',
  },

  '& .MuiOutlinedInput-root': {
    height: '100%',
  },
  '& .MuiInput-underline': {
    borderBottom: 'none',
  },

  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },

  '& .MuiInputBase-root:before': {
    borderBottom: 'none',
  },
}

export const dateRangeInputStyles = {
  height: '40px',
  '& .MuiInputBase-root': {
    height: '100%',
    borderBottom: 'none',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
  },

  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
}

export const rangeInputStyles = {
  borderBottom: '1px solid #ccc',
  height: '40px',
  '& .MuiInputBase-root': {
    height: '100%',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
  },

  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
}

export const dateFilterContainer = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  pr: '15px',
}

export const rangeFilterContainer = {
  width: '100%',
  height: '100%',
  position: 'relative',
}

export const rangePickersContainer = {
  width: '100%',
  display: 'flex',
  background: 'rgb(250 250 250)',
  flexDirection: 'column',
  gap: '5px',
  position: 'absolute',
  padding: '5px 10px 5px 5px',
  top: '0',
  left: '0',
  boxShadow: '0 0 1px rgba(0, 0, 0, .1), 0 1px 3px rgba(0, 0, 0, .2)',
}
